
import { defineComponent } from 'vue';
import VariavelVisualizacao from './VariavelVisualizacao.vue';
import VariavelEdicao from './VariavelEdicao.vue';
import { VariavelEditavel } from '@/dominio/editor/questoes/comum/variavel/VariavelEditavel';

export default defineComponent({
    name: 'ItemDeVariavel',
    components: {
        VariavelVisualizacao,
        VariavelEdicao,
    },
    props: {
        variavel: { type: VariavelEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        editar(variavel: VariavelEditavel) {
            this.$emit('editar', variavel);
        },
        excluir(variavel: VariavelEditavel) {
            this.$emit('excluir', variavel);
        },
        descer(variavel: VariavelEditavel) {
            this.$emit('descer', variavel);
        },
        subir(variavel: VariavelEditavel) {
            this.$emit('subir', variavel);
        },
    },
    emits: ['editar', 'excluir', 'descer', 'subir'],
});
